import GsapdGroupc from './gsapdGroupc';
import GsapdGroupd from './gsapdGroupd';
import GsapdGroupe from './gsapdGroupe';
import TabInfo from './components/tabinfo';
import UseTime from './components/useTime';
import OtherList from '@/components/ProductCommon/OtherList';
import IRAFooter from '@/components/IRAComp/IRAFooterNew';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic({ otherProductData }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    return (
        <>
            <div className="blockWrapper block-TabInfo">
                <TabInfo />
            </div>
            <GsapdGroupc />
            <GsapdGroupd />
            <div className="blockWrapper block-UseTime">
                <UseTime />
            </div>
            <GsapdGroupe />
            {locale === 'us' && <IRAFooter borderTopColor="transparent" bgColor="transparent" boxStyle={{ margin: '0 auto 90px', width: '1120px' }} />}
            <OtherList theme="black" data={otherProductData} />
        </>
    );
}
